import { createSlice } from '@reduxjs/toolkit';
import { IAbsencesContext } from '../../interfaces/StoreTypes';

const initialState: IAbsencesContext = {
  absences: [],
  holidays: [],
  sickDays: [],
  absencesLastRefresh: 0,
};

const absencesSlice = createSlice({
  name: 'absences',
  initialState,
  reducers: {
    setAbsences: (state, action) => {
      state.absences = action.payload;
    },
    setHolidays: (state, action) => {
      state.holidays = action.payload;
    },
    setSickDays: (state, action) => {
      state.sickDays = action.payload;
    },
    setAbsencesLastRefresh: (state, action) => {
      state.absencesLastRefresh = action.payload;
    },
  },
});

export const { setAbsences, setHolidays, setSickDays, setAbsencesLastRefresh } = absencesSlice.actions;

export default absencesSlice.reducer;
